import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { geometryTypes as t } from "../../geometry.js";
import i from "../../TimeExtent.js";
import { JSONMap as r } from "../../core/jsonMap.js";
import { JSONSupport as s } from "../../core/JSONSupport.js";
import { clone as o } from "../../core/lang.js";
import { isSome as n } from "../../core/maybe.js";
import { property as a } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as l } from "../../core/accessorSupport/decorators/subclass.js";
import p from "../../rest/support/Query.js";

var _c;

var m = new r({
  esriSpatialRelIntersects: "intersects",
  esriSpatialRelContains: "contains",
  esriSpatialRelCrosses: "crosses",
  esriSpatialRelDisjoint: "disjoint",
  esriSpatialRelEnvelopeIntersects: "envelope-intersects",
  esriSpatialRelIndexIntersects: "index-intersects",
  esriSpatialRelOverlaps: "overlaps",
  esriSpatialRelTouches: "touches",
  esriSpatialRelWithin: "within",
  esriSpatialRelRelation: "relation"
}),
    u = new r({
  esriSRUnit_Meter: "meters",
  esriSRUnit_Kilometer: "kilometers",
  esriSRUnit_Foot: "feet",
  esriSRUnit_StatuteMile: "miles",
  esriSRUnit_NauticalMile: "nautical-miles",
  esriSRUnit_USNauticalMile: "us-nautical-miles"
});

var d = _c = /*#__PURE__*/function (_s) {
  _inherits(c, _s);

  var _super = _createSuper(c);

  function c(e) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, e), _this.where = null, _this.geometry = null, _this.spatialRelationship = "intersects", _this.distance = void 0, _this.objectIds = null, _this.units = null, _this.timeExtent = null;
    return _this;
  }

  _createClass(c, [{
    key: "createQuery",
    value: function createQuery() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = this.where,
          i = this.geometry,
          r = this.spatialRelationship,
          s = this.timeExtent,
          n = this.objectIds,
          a = this.units,
          l = this.distance;
      return new p(_objectSpread({
        geometry: o(i),
        objectIds: o(n),
        spatialRelationship: r,
        timeExtent: o(s),
        where: t,
        units: a,
        distance: l
      }, e));
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = this.where,
          t = this.geometry,
          i = this.spatialRelationship,
          r = this.timeExtent,
          s = this.objectIds,
          n = this.units,
          a = this.distance;
      return new _c({
        geometry: o(t),
        objectIds: o(s),
        spatialRelationship: i,
        timeExtent: o(r),
        where: e,
        units: n,
        distance: a
      });
    }
  }]);

  return c;
}(s);

e([a({
  type: String,
  json: {
    write: !0
  }
})], d.prototype, "where", void 0), e([a({
  types: t,
  json: {
    write: !0
  }
})], d.prototype, "geometry", void 0), e([a({
  type: m.apiValues,
  json: {
    name: "spatialRel",
    read: {
      reader: m.read
    },
    write: {
      allowNull: !1,
      writer: m.write,
      overridePolicy: function overridePolicy() {
        return {
          enabled: n(this.geometry)
        };
      }
    }
  }
})], d.prototype, "spatialRelationship", void 0), e([a({
  type: Number,
  json: {
    write: {
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: null != e && null != this.geometry
        };
      }
    }
  }
})], d.prototype, "distance", void 0), e([a({
  type: [Number],
  json: {
    write: !0
  }
})], d.prototype, "objectIds", void 0), e([a({
  type: u.apiValues,
  json: {
    read: u.read,
    write: {
      writer: u.write,
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: null != e && null != this.geometry
        };
      }
    }
  }
})], d.prototype, "units", void 0), e([a({
  type: i,
  json: {
    write: !0
  }
})], d.prototype, "timeExtent", void 0), d = _c = e([l("esri.layers.support.FeatureFilter")], d);
var y = d;
export { y as default };